var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6357 0.253754C6.62762 0.253754 2.66699 2.92563 2.66699 7.25C2.66699 10 4.21387 11.5625 5.15137 11.5625C5.53824 11.5625 5.76074 10.4844 5.76074 10.18C5.76074 9.81688 4.83512 9.04313 4.83512 7.53125C4.83512 4.39063 7.22574 2.16375 10.3195 2.16375C12.9795 2.16375 14.9482 3.67563 14.9482 6.45313C14.9482 8.5275 14.1164 12.4181 11.4207 12.4181C10.4482 12.4181 9.61574 11.715 9.61574 10.7075C9.61574 9.23063 10.647 7.80125 10.647 6.2775C10.647 3.69188 6.97887 4.16063 6.97887 7.28563C6.97887 7.94188 7.06074 8.66813 7.35387 9.26625C6.81449 11.5869 5.71324 15.0438 5.71324 17.4344C5.71324 18.1725 5.81887 18.8994 5.88887 19.6375C6.02137 19.7863 5.95512 19.7706 6.15824 19.6963C8.12699 17.0006 8.05699 16.4738 8.94762 12.9463C9.42824 13.8606 10.6701 14.3525 11.6545 14.3525C15.8026 14.3525 17.6664 10.3094 17.6664 6.665C17.6664 2.78625 14.3145 0.255004 10.6351 0.255004L10.6357 0.253754Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPinterest);
export default __webpack_public_path__ + "static/media/social-pinterest.1eeef861f1b22edcbdfaa27272a50b6b.svg";
export { ForwardRef as ReactComponent };